import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/agents")({
  component: () => (
    <Breadcrumb label="Agents" to="/agents">
      <Outlet />
    </Breadcrumb>
  ),
});
